import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-13657db8")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Pic = _resolveComponent("Pic")
  const _component_TheSelectBar = _resolveComponent("TheSelectBar")

  return (_openBlock(), _createBlock(_component_TheSelectBar, {
    options: _ctx.studies,
    selected: _ctx.selected
  }, {
    default: _withId(({item, active, select}) => [
      _createVNode("div", {
        class: ["flex-1 f-sm py-4 c-tip", ['study_item', {active}, item.class]],
        onClick: ($event: any) => (_ctx.change(item, select))
      }, [
        _createTextVNode(_toDisplayString(item.label) + " ", 1),
        (item.elite && active)
          ? (_openBlock(), _createBlock(_component_Icon, {
              key: 0,
              name: "membership",
              class: "c-asst",
              sm: ""
            }))
          : (item.elite)
            ? (_openBlock(), _createBlock(_component_Pic, {
                key: 1,
                src: "elite",
                width: "16",
                height: "16",
                class: "v-middle"
              }))
            : _createCommentVNode("", true)
      ], 10, ["onClick"])
    ]),
    _: 1
  }, 8, ["options", "selected"]))
})